"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = escapeRegExp;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

/**
 * Replace special regex chars with the string literals (for use in RegExp constructor)
 * Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 * More info: https://en.wikipedia.org/wiki/ReDoS#Evil_regexes
 */
function escapeRegExp(string) {
  //  $& means the whole matched string.
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}